import UnionRightRail from "@xo-union/tk-component-right-rail";
import React from "react";
import styles from "./index.css";
export * from "./components/index.js";
var RightRail = function RightRail(_ref) {
  var open = _ref.open,
    children = _ref.children,
    _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? true : _ref$overlay,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onEscapeKey = _ref.onEscapeKey;
  var classNames = [styles.railContainer, styles.overflow, className, styles[open ? 'open' : 'close']];
  return /*#__PURE__*/React.createElement(UnionRightRail, {
    className: classNames.join(' '),
    visible: open,
    overlay: overlay,
    onEscapeKey: onEscapeKey
  }, open && children);
};
export default RightRail;